import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from 'hooks/useQuery';
import QueryKeys from './keys';
import { SMS } from 'domains/content/types';

/**
 * Hook to fetch all SMS content
 *
 * @param reactQueryOptions Additional react-query options
 * @param axiosOptions Options for axios request (e.g., params for query string)
 * @returns Query result with array of SMS content items
 */
const useSmses = (
    reactQueryOptions?: UseQueryOptions<SMS[], Error>,
    axiosOptions?: { params?: { status?: string } }
) => {
    // Always filter by status=published,live
    const mergedAxiosOptions = {
        ...axiosOptions,
        params: {
            ...axiosOptions?.params,
            status: 'published,live',
        },
    };

    return useQuery<SMS[]>(QueryKeys.SMSES, CuredApiPaths.SMS, reactQueryOptions, mergedAxiosOptions);
};

export default useSmses;
